import type { ReceiptTemplate } from '../schema';

export const chanelTemplate: ReceiptTemplate = {
  id: 'chanel',
  name: 'Chanel Receipt',
  brand: 'CHANEL',
  description: 'Luxury fashion house receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'chanel-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/chanel.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'CHANEL BOUTIQUE',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chanel-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'chanel-date', label: 'Date:', value: '01/04/2026' },
          { id: 'chanel-trans', label: 'Trans:', value: '294817' },
          { id: 'chanel-assoc', label: 'Advisor:', value: 'JAMES' },
        ],
        column2: [
          { id: 'chanel-time', label: 'Time:', value: '15:42:18' },
          { id: 'chanel-store', label: 'Store:', value: '0127' },
          { id: 'chanel-reg', label: 'Reg:', value: '01' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chanel-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'chanel-item-1', name: 'Classic Flap Bag Medium', quantity: '1', price: '10800.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chanel-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'chanel-subtotal', label: 'Subtotal', value: '10,800.00', isBold: false, isLarge: false },
          { id: 'chanel-tax', label: 'Tax (8.875%)', value: '958.50', isBold: false, isLarge: false },
          { id: 'chanel-total', label: 'TOTAL', value: '11,758.50', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'chanel-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'chanel-card', label: 'AMEX', value: '***********4144' },
          { id: 'chanel-auth', label: 'Auth', value: '847291' },
          { id: 'chanel-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'chanel-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'CH294817012726',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chanel-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns accepted within 14 days\nwith tags attached and original receipt.\nThank you for choosing CHANEL.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

